import { render, staticRenderFns } from "./serive.vue?vue&type=template&id=bbe351de&"
import script from "./serive.vue?vue&type=script&lang=js&"
export * from "./serive.vue?vue&type=script&lang=js&"
import style0 from "./serive.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports